'use client'

import React from 'react'

import { chakra } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { facilityPillStyles } from './FacilityPill.styles'
import { Pill, PillProps } from './Pill'

export type FacilityPillProps = Omit<PillProps, 'bg' | 'color'> & {
  colorScheme?: ColorScheme
  endAction?: React.ReactNode
}

export const FacilityPill = ({
  colorScheme = 'dark',
  children,
  endAction,
  ...rest
}: FacilityPillProps) => (
  <Pill {...facilityPillStyles(colorScheme)} {...rest}>
    <chakra.span
      display='block'
      flex='1'
      minWidth='0'
      overflow='hidden'
      textOverflow='ellipsis'
      whiteSpace='nowrap'
    >
      {children}
    </chakra.span>
    {endAction && (
      <chakra.span display='inline-flex' flexShrink='0'>
        {endAction}
      </chakra.span>
    )}
  </Pill>
)
